import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AuthPane from './AuthPane';
import ContactPane from '../ContactPane';
import { initializeAuth, handleOAuthCallback, hideAuthModals, selectAuth, tokenSignIn } from '../../features/authSlice';
import { isOAuthEnabled } from '../../config/auth';

const AuthContainer = () => {
  const dispatch = useDispatch();
  const { showContact } = useSelector(selectAuth);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    // Auto sign-in using a pre-obtained Cognito ID token passed by the native iOS app
    const inboundToken = urlParams.get('token');
    if (inboundToken) {
      // urlParams.delete('token');
      // const remainingParams = urlParams.toString();
      // const cleanUrl = window.location.origin + window.location.pathname + (remainingParams ? '?' + remainingParams : '');
      // window.history.replaceState({}, document.title, cleanUrl);
      dispatch(tokenSignIn(inboundToken));
      return;
    }

    // Initialize authentication on app load
    dispatch(initializeAuth());

    // Handle OAuth callback if enabled and URL contains callback parameters
    if (isOAuthEnabled()) {
      const hasOAuthParams = urlParams.get('code') || urlParams.get('access_token') || urlParams.get('id_token');

      if (hasOAuthParams) {
        console.log('OAuth callback detected, handling...');
        dispatch(handleOAuthCallback());

        // Clean up URL parameters after handling callback
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    }
  }, [dispatch]);

  return (
    <>
      <AuthPane />
      <ContactPane 
        show={showContact} 
        onClose={() => dispatch(hideAuthModals())} 
      />
    </>
  );
};

export default AuthContainer;
